import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Skeleton, Typography } from 'antd';
import React from 'react';

import { useGetBreadcrumb } from '@/api';

export type FolderBreadcrumbProps = {
  folderPath: string;
  onFolderSelected: (path: string) => void;
  maxCrumbWidth?: string;
};

export function FolderBreadcrumb({
  folderPath,
  onFolderSelected,
  maxCrumbWidth = '120px',
}: FolderBreadcrumbProps): React.JSX.Element {
  const { data, isLoading } = useGetBreadcrumb(folderPath);

  if (isLoading || !data) {
    return <Skeleton paragraph={false} active />;
  }

  const labelStyle: React.CSSProperties = {
    maxWidth: maxCrumbWidth,
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
  };

  const items = [
    {
      title: folderPath ? (
        <a style={{ padding: 0 }} onClick={() => onFolderSelected('')}>
          <HomeOutlined style={{ fontSize: 16 }} title={'Home'} />
        </a>
      ) : (
        <HomeOutlined style={{ fontSize: 16 }} title={'Home'} />
      ),
    },
    ...data.breadcrumb.map((item, idx) => ({
      title:
        idx === data.breadcrumb.length - 1 ? (
          <Typography.Text style={labelStyle} title={item.name}>
            {item.name}
          </Typography.Text>
        ) : (
          <a style={{ padding: 0 }} onClick={() => onFolderSelected(item.path)}>
            <Typography.Text style={labelStyle} title={item.name}>
              {item.name}
            </Typography.Text>
          </a>
        ),
    })),
  ];

  return <Breadcrumb items={items} style={{ marginBottom: 16, flexWrap: 'wrap' }} />;
}
